import { styled, TableCell } from '@mui/material';

export const AlignStatusContainer = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: '1rem',
}));

export const TableCellStyled = styled(TableCell)(({ theme }) => ({
  color: 'white',
  padding: '1rem 1.25rem',
  width: '30%',
  [theme.breakpoints.up('md')]: {
    padding: '1rem 3rem',
  },
  background: theme.palette.primary.dark,
  borderBottomColor: theme.palette.secondary.dark,
}));

export const TableCellGroup = styled(TableCellStyled)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));
